import React, {Component, ReactElement} from 'react'
import {ConditionTableFixed} from '../../../../styledComponents/adminPage/ConditionTable';
import {StyledTableCaption, TableRowName} from '../../../../styledComponents/adminPage/Table';
import { TableRow, TableCell, TableBody } from '@mui/material';

interface Props {
    reserveFamilyName: string
    reserveFirstName: string
    reserveRoleName: string
    stayAvailability: boolean
}

class NatAdminFacilityReserveReserveUserInfoViewComponent extends Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    render(): ReactElement {
        const {reserveFamilyName, reserveFirstName, reserveRoleName} = this.props;

        return (
            <ConditionTableFixed>
                <colgroup>
                    <col width={'15%'}/>
                    <col width={'15%'}/>
                    <col width={'10%'}/>
                    <col width={'15%'}/>
                    <col width={'10%'}/>
                    <col width={'10%'}/>
                </colgroup>
                <StyledTableCaption>予約者情報</StyledTableCaption>
                <TableBody>
                    <TableRow>
                        <TableRowName>予約者氏名</TableRowName>
                        <TableCell colSpan={5}>
                            {reserveFamilyName} {reserveFirstName}
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>権限</TableRowName>
                        <TableCell colSpan={5}>
                            {reserveRoleName}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </ConditionTableFixed>
        )
    }
}

export default NatAdminFacilityReserveReserveUserInfoViewComponent;
